<script setup>
import { Link } from "@inertiajs/vue3";
import PublicAppLayout from "@/Layouts/PublicAppLayout.vue";
</script>

<template>
    <PublicAppLayout
        :title="$t('Ceļu satiksmes noteikumu apguve')"
    >
        <main class="isolate">
            <!-- Hero section -->
            <div class="relative pt-14">
                <div class="py-24 sm:py-32">
                    <div class="mx-auto max-w-7xl px-6 lg:px-8">
                        <div class="mx-auto max-w-2xl text-center">
                            <h1
                                class="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl sm:leading-tight"
                            >
                                <template v-if="$i18n.locale === 'lv'">
                                    <span class="bg-bava-dark text-bava-primary px-5 rounded-sm">Mācīties</span>
                                    ceļu satiksmes noteikumus nekad nav bijis tik ērti un
                                    <br />
                                    <span class="bg-bava-dark text-bava-primary px-5 rounded-sm">vienkārši</span>
                                </template>
                                <template v-else-if="$i18n.locale === 'ru'">
                                    <span class="bg-bava-dark text-bava-primary px-5 rounded-sm">Изучать</span>
                                    правила дорожного движения никогда не было так удобно и
                                    <br />
                                    <span class="bg-bava-dark text-bava-primary px-5 rounded-sm">просто</span>
                                </template>
                            </h1>
                            <p class="mt-20 text-lg leading-8 text-gray-600">
                                <template v-if="$i18n.locale === 'lv'">
                                    Noteikti noskatities šo video, lai zinātu kā pareizi lietot e-vides mācību materiālu un kādi noteikumi obligāti ir jāievēro.
                                </template>
                                <template v-else-if="$i18n.locale === 'ru'">
                                    Обязательно посмотрите это видео, чтобы знать, как правильно использовать учебные материалы e-vide и какие правила обязательно нужно соблюдать.
                                </template>
                            </p>
                            <div
                                class="mt-10 flex items-center justify-center gap-x-6"
                            >
                                <Link
                                    :href="
                                        '/' +
                                        $i18n.locale +
                                        '/' +
                                        'ka-lietot-evidi'
                                    "
                                    class="btn-primary"
                                    >{{ $t('Kā lietot e-vidi?') }}
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div class="mx-auto max-w-7xl">
                        <div class="mt-16 flow-root sm:mt-24">
                            <img src="/img/pc.jpg" alt="" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="relative pt-14">
                <div class="py-24 sm:py-32">
                    <div class="mx-auto max-w-7xl px-6 lg:px-8">
                        <div class="mx-auto max-w-3xl text-center">
                            <h1
                                class="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl sm:leading-tight"
                            >
                                <template v-if="$i18n.locale === 'lv'">
                                    <span class="bg-bava-dark text-bava-primary px-5 rounded-sm">Apgūstiet</span>
                                    ceļu satiksmes noteikumus Jums ērtā
                                    <br />
                                    <span class="bg-bava-dark text-bava-primary px-5 rounded-sm">laikā</span>
                                    un
                                    <span class="bg-bava-dark text-bava-primary px-5 rounded-sm">vietā</span>
                                </template>
                                <template v-else-if="$i18n.locale === 'ru'">
                                    <span class="bg-bava-dark text-bava-primary px-5 rounded-sm">Изучайте</span>
                                    правила дорожного движения в удобное для вас
                                    <br />
                                    <span class="bg-bava-dark text-bava-primary px-5 rounded-sm">время</span>
                                    и
                                    <span class="bg-bava-dark text-bava-primary px-5 rounded-sm">место</span>
                                </template>
                            </h1>
                            <p class="mt-20 text-lg leading-8 text-gray-600">
                                <template v-if="$i18n.locale === 'lv'">
                                    Mācīties varēsiet no jebkuras ierīces - datora, telefona vai planšetdatora. Mācību materiāli ir sadalīti pa 5 līdz 20 minūšu gariem video.
                                </template>
                                <template v-else-if="$i18n.locale === 'ru'">
                                    Учиться можно с любого устройства - компьютера, телефона или планшета. Учебные материалы разделены на видео длиной от 5 до 20 минут.
                                </template>
                            </p>
                            <div
                                class="mt-10 flex items-center justify-center gap-x-6"
                            >
                                <a
                                    :href="`/${$i18n.locale}/login`"
                                    class="btn-primary"
                                    >{{ $t('Pieslēgties') }}</a
                                >
                            </div>
                        </div>
                    </div>
                    <div class="mx-auto max-w-7xl">
                        <div class="mt-16 flow-root sm:mt-24">
                            <img src="/img/phone.jpg" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </PublicAppLayout>
</template>
